import { all, call, put, takeEvery } from "redux-saga/effects";

import { SetDarkModeActionCreator, SetNavExpandedActionCreator } from "./actions";

const DARK_KEY = "dark_mode_override";

function* darkMode() {
  const storedPref = window.localStorage.getItem(DARK_KEY);
  if (storedPref) {
    yield put(SetDarkModeActionCreator(storedPref === "true"));
  } else {
    // yield put(SetDarkModeActionCreator(window.matchMedia("(prefers-color-scheme: dark)").matches));
  }
  yield takeEvery(`${SetDarkModeActionCreator.toString()}`, (action: ReturnType<typeof SetDarkModeActionCreator>) => {
    window.localStorage.setItem(DARK_KEY, `${action.payload}`);
  });
}

const NAV_EXPANDED_KEY = "nav_expanded";

function* persistNav() {
  const storedPref = window.localStorage.getItem(NAV_EXPANDED_KEY);
  if (storedPref !== null) {
    yield put(SetNavExpandedActionCreator(storedPref === "true"));
  }
  yield takeEvery(
    `${SetNavExpandedActionCreator.toString()}`,
    (action: ReturnType<typeof SetNavExpandedActionCreator>) => {
      window.localStorage.setItem(NAV_EXPANDED_KEY, `${action.payload}`);
    }
  );
}

export function* frameSagas() {
  yield all([call(darkMode), call(persistNav)]);
}
